module.exports = __webpack_public_path__ + "7446ddf6be2dd9e974972666a989623f.png";